import history from '../../utils/history';
import { getUsers } from './api/users';
import { getRetailerSuppliers } from './api/retailers';
import { alertError } from './alert';
import { SUPPLIER, RETAILER } from '../../constants/roles';
import {
  ROLES_SUPPLIER,
  ROLES_RETAILER,
  ROLES_USER,
  ROLES_WITH_USER,
  ROLES_CURRENT_ROLE,
  ROLES_SUPPLIER_ID,
  ROLES_RETAILER_ID,
  ROLES_CLEAR_PERMISSIONS,
  ROLES_RETAILER_SUPPLIERS,
} from '../constants/rolesTypes';

export const rolesClearPermissions = { type: ROLES_CLEAR_PERMISSIONS };
export const setRoleUser = (data) => ({ type: ROLES_USER, payload: data });
export const setRolesWithUser = (data) => ({ type: ROLES_WITH_USER, payload: data });
export const setRolesCurrentRole = (role) => ({ type: ROLES_CURRENT_ROLE, payload: role });
export const setRolesSupplierId = (id) => ({ type: ROLES_SUPPLIER_ID, payload: id });
export const setRolesRetailerId = (id) => ({ type: ROLES_RETAILER_ID, payload: id });
export const setRolesRetailerSuppliers = (suppliers) => ({ type: ROLES_RETAILER_SUPPLIERS, payload: suppliers });

export const setRole = (type, role) => {
  switch (type) {
    case SUPPLIER:
      return { type: ROLES_SUPPLIER, payload: role };

    case RETAILER:
      return { type: ROLES_RETAILER, payload: role };

    default:
      return { type: ROLES_CLEAR_PERMISSIONS };
  }
};

export const getRoles = () => async (dispatch) => {
  try {
    const response = await getUsers();
    dispatch(setRolesWithUser(response));
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const setRolesUpdateRole = (id, role) => (dispatch) => {
  dispatch(setRolesCurrentRole(role));

  switch (role) {
    case SUPPLIER:
      dispatch(setRolesSupplierId(id));
      break;

    case RETAILER:
      dispatch(setRolesRetailerId(id));
      break;

    default:
      break;
  }
};

export const setRolesRole = (id, role) => async (dispatch) => {
  dispatch(setRolesUpdateRole(id, role));

  switch (role) {
    case SUPPLIER:
      history.push(`/suppliers/${id}`);
      break;

    case RETAILER:
      const response = await getRetailerSuppliers(id);
      if (response.data) {
        dispatch(setRolesRetailerSuppliers(response.data));
      }

      history.push(`/retailers/${id}`);
      break;

    default:
      break;
  }
};
